module.exports = __webpack_public_path__ + "static/media/search.045c8985.svg";